export const C = {
  bg:           '#F5F2E9',
  bgGrad:       'linear-gradient(170deg, #FEFCF6 0%, #F5F2E9 55%, #EDE8DC 100%)',
  surface:      '#FEFCF6',
  surfaceAlt:   '#FFFFFF',
  border:       'rgba(0,77,64,0.09)',
  borderStrong: 'rgba(0,77,64,0.15)',
  teal:         '#004D40',
  tealSoft:     'rgba(0,77,64,0.07)',
  tealMed:      'rgba(0,77,64,0.12)',
  amber:        '#FFBC00',
  amberSoft:    'rgba(255,188,0,0.10)',
  amberStrong:  'rgba(255,188,0,0.22)',
  text:         '#1B1A17',
  textMuted:    'rgba(27,26,23,0.52)',
  textDim:      'rgba(27,26,23,0.30)',
  red:          '#C0392B',
  redSoft:      'rgba(192,57,43,0.09)',
  green:        '#00806A',
  greenSoft:    'rgba(0,128,106,0.10)',
  orange:       '#CC4400',
  orangeSoft:   'rgba(255,102,0,0.10)',
  font:         "'Inter', -apple-system, system-ui, sans-serif",
  shadow:       '0 2px 16px rgba(0,77,64,0.08), 0 1px 4px rgba(0,0,0,0.05)',
  shadowMd:     '0 6px 28px rgba(0,77,64,0.11), 0 2px 8px rgba(0,0,0,0.07)',
};
